import { Injectable, computed, signal } from '@angular/core';
import type { Notification } from '../models/notification.model';

// Contenido quemado reutilizado tal cual del panel de notificaciones ya existente en
// app/mensajes.html (no se inventan textos nuevos, ver parte_10 "Instrucciones para el
// agente"). Los "hace 5 min"/"hace 20 min"/"hace 1h" del HTML original se derivan acá como
// timestamps reales para que RelativeTimePipe (Fase 2) los calcule en vez de quemar el texto.
// Campos en snake_case porque así los devuelve el backend (sin capa de traducción).
const now = Date.now();
const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: '55555555-5555-4555-8555-555555555551',
    business_id: '33333333-3333-4333-8333-333333333333',
    account_id: '22222222-2222-4222-8222-222222222222',
    target_user_id: null,
    notification_type: 'order_new',
    title: 'Nuevo pedido #VD-1043',
    body: 'Maria Lopez',
    icon: 'shopping_bag',
    link_url: null,
    link_entity_type: 'order',
    link_entity_id: null,
    is_read: false,
    read_at: null,
    created_at: new Date(now - 5 * 60 * 1000).toISOString(),
    updated_at: new Date(now - 5 * 60 * 1000).toISOString(),
  },
  {
    id: '55555555-5555-4555-8555-555555555552',
    business_id: '33333333-3333-4333-8333-333333333333',
    account_id: '22222222-2222-4222-8222-222222222222',
    target_user_id: null,
    notification_type: 'payment_approved',
    title: 'Pago confirmado #VD-1041',
    body: 'Wompi',
    icon: 'payments',
    link_url: null,
    link_entity_type: 'payment',
    link_entity_id: null,
    is_read: false,
    read_at: null,
    created_at: new Date(now - 20 * 60 * 1000).toISOString(),
    updated_at: new Date(now - 20 * 60 * 1000).toISOString(),
  },
  {
    id: '55555555-5555-4555-8555-555555555553',
    business_id: '33333333-3333-4333-8333-333333333333',
    account_id: '22222222-2222-4222-8222-222222222222',
    target_user_id: null,
    notification_type: 'conversation_new',
    title: 'Bot detuvo conversacion',
    body: '+57 300 123 4567',
    icon: 'smart_toy',
    link_url: null,
    link_entity_type: 'conversation',
    link_entity_id: null,
    is_read: false,
    read_at: null,
    created_at: new Date(now - 60 * 60 * 1000).toISOString(),
    updated_at: new Date(now - 60 * 60 * 1000).toISOString(),
  },
];

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _notifications = signal<Notification[]>(MOCK_NOTIFICATIONS);

  readonly notifications = this._notifications.asReadonly();
  readonly unreadCount = computed(() => this._notifications().filter((n) => !n.is_read).length);

  markAsRead(notificationId: string): void {
    this._notifications.update((list) =>
      list.map((n) => (n.id === notificationId ? { ...n, is_read: true, read_at: new Date().toISOString() } : n)),
    );
  }
}
